export const DELETE_TRACK = "DELETE_TRACK";

export const TOGGLE_TRACK_DRAWER = "TOGGLE_TRACK_DRAWER";

export const CREATE_TRACK = "CREATE_TRACK";

export const SET_CURRENT_PLAYED_TRACK = "SET_CURRENT_PLAYED_TRACK";
